import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../../Context/Cartcontext';
import './PaymentSuccess.css';

// Landing page for the gateway's return_url. PayHere and Koko both redirect here
// after a payment, so it has to stand on its own: the checkout component is long
// gone by the time the browser comes back.
const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId') || searchParams.get('order_id');

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(Boolean(orderId));
  const { updateCart } = useCart();

  const baseURL = window.APP_CONFIG?.API_URL || 'https://backendweb.properteck.lk';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // The cart survives the redirect out to the gateway, so clear it here too —
    // same sweep Checkout does in clearAllCartData().
    try {
      updateCart?.([]);
      window.dispatchEvent(new CustomEvent('clearCart'));
      Object.keys(localStorage).forEach((key) => {
        if (key.toLowerCase().includes('cart')) localStorage.removeItem(key);
      });
    } catch (err) {
      console.warn('Failed to clear cart after payment:', err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!orderId) return;

    const fetchOrder = async () => {
      try {
        // Endpoint name has an upstream typo ("byumber") — matches orederRoutes.js
        const response = await fetch(
          `${baseURL}/api/order/getorderbyumber/${encodeURIComponent(orderId)}`
        );
        const data = await response.json();
        if (data.success && data.order) {
          setOrder(data.order);
        }
      } catch (error) {
        console.error('Failed to load order:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId, baseURL]);

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <div className="payment-success-icon">✓</div>
        <h1>Payment Successful!</h1>
        <p className="payment-success-lead">
          Thank you for your order. A confirmation email is on its way.
        </p>

        {loading && <p className="payment-success-loading">Loading your order details…</p>}

        {!loading && order && (
          <div className="payment-success-details">
            <div className="payment-success-row">
              <span>Order Number</span>
              <strong>{order.orderNumber}</strong>
            </div>
            <div className="payment-success-row">
              <span>Total</span>
              <strong>{Number(order.total).toLocaleString()} LKR</strong>
            </div>
            <div className="payment-success-row">
              <span>Items</span>
              <strong>{order.items?.length || 0}</strong>
            </div>
            <div className="payment-success-row">
              <span>Status</span>
              <strong className="payment-success-status">{order.orderStatus}</strong>
            </div>
          </div>
        )}

        {!loading && !order && orderId && (
          <div className="payment-success-details">
            <div className="payment-success-row">
              <span>Order Number</span>
              <strong>{orderId}</strong>
            </div>
            <p className="payment-success-note">
              Your payment went through. Order details are still being finalised &mdash;
              the confirmation email will have everything.
            </p>
          </div>
        )}

        <Link to="/" className="payment-success-btn">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
